<template>
  <div
      class="position-relative w-100 h-100"
      :class="bgLayoutMap[props.effectMode]"
      :style="{
        maxWidth:`${defaultWidth}px`,
        maxHeight:`${defaultHeight}px`
      }"
  >
    <div class="text_wrap"
         :class="[
             horizontalPosition[textLayoutData.obj.HorizontalAlignment],
             verticalPosition[textLayoutData.obj.VerticalAlignment],
            { 'center d-flex align-items-center justify-content-evenly': textLayoutData.obj.HorizontalAlignment === 'Center' && textLayoutData.obj.VerticalAlignment === 'Center' }
            ]"
         :style="{
            textShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`,
            opacity: `${textOpacity}`
           }"
    >
      <template v-for="(c, index) in textContent.arr" :key="c.Text">
        <div
            class="flex-column"
            :class="[
                  index === sliderSensorIndex ? 'd-inline-flex' : 'd-none',
                  columnTextAlign[textLayoutData.obj.TextAlignment]
                  ]"
        >
          <div
              class="
                top_font_wrap
                top_margin_fix
                sub_font_size
                sub_font_family
                d-inline-flex
                align-items-center
                flex-nowrap
              "
              :class="[
                    props.effectMode === 'Blossom' ? 'justify-content-between' : 'justify-content-evenly',
                    `sub_font_family_${props.effectMode}_${textType}`,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `top_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                ]"
              :style="{
                  'color': changeToRgba(textLayoutData.obj.FontColors[0]),
                }"
          >
              <div
                  v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
                  class="d-inline-block me-2 blossom_custom_space"
                  :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_start' : ''"
                  :style="{
                    backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[0]),
                    boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                  }"
              />
            <div class="sub_letter_space" :class="[`sub_letter_space_${props.effectMode}_${textType}`]">{{ c.Type }}</div>
            <div
                v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
                class="d-inline-block ms-2 blossom_custom_space"
                :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_end' : ''"
                :style="{
                    backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[0]),
                    boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                  }"
            />
          </div>
          <div
              class="
                medium_font_wrap
                main_font_size
                d-inline-flex
                align-items-center
                flex-nowrap
              "
              :class="[
                    props.effectMode === 'Blossom' ? 'justify-content-between' : 'justify-content-evenly',
                    mainFontFamily,
                    `main_font_size_${props.effectMode}_${textType}`
                    ]"
              :style="{
            'color': changeToRgba(textLayoutData.obj.FontColors[1]),
              }"
          >
            <div class="main_letter_space" :class="[`main_letter_space_${props.effectMode}_${textType}`]">{{ c.Value }}</div>
          </div>
          <div
              class="
               bottom_font_wrap
               bottom_margin_fix
               sub_font_size
               sub_font_family
               d-inline-flex
               align-items-center
               flex-nowrap
              "
              :class="[
                    props.effectMode === 'Blossom' ? 'justify-content-between' : 'justify-content-evenly',
                    `sub_font_family_${props.effectMode}_${textType}`,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `bottom_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                    ]"
              :style="{
                  'color': changeToRgba(textLayoutData.obj.FontColors[2]),
              }"
          >
              <div
                  v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
                  class="d-inline-block me-2 blossom_custom_space"
                  :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_start' : ''"
                  :style="{
                    backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[2]),
                    boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                  }"
              />
            <div class="sub_letter_space" :class="[`sub_letter_space_${props.effectMode}_${textType}`]">{{ c.Unit }}</div>
            <div
                v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
                class="d-inline-block ms-2 blossom_custom_space"
                :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_end' : ''"
                :style="{
                  backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[2]),
                  boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                  }"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup>
import defaultValue from "@/utils/defaultValue";
import textModeTool from "@/utils/textModeTool";

import {ref, reactive, watchEffect, onUnmounted, watch} from 'vue'
import changeToRgba from '@/utils/globalFunc'

const {defaultWidth, defaultHeight} = defaultValue()
const {
  bgLayoutMap,
  horizontalPosition,
  verticalPosition,
  columnTextAlign,
  initMainFontFamily
} = textModeTool()

const props = defineProps(["textData", "sensorValue", 'effectMode'])
const sensorJsonObj = reactive({obj: props.sensorValue}) // 取得sensor資料
const texts = reactive(props.textData)
let textType = ref('')
let textLayoutData = reactive({obj: {}})
let controllerLoopSecond = ref(0)
let textContent = reactive({arr: []})
let mainFontFamily = ref('')
let sensorsSelectedValue = ref([])

let intervalID = ref(null)
let sliderSensorIndex = ref(0)
let textShadow = ref('35%')
let textOpacity = ref('100%')
const processTextContent = (sensorsSelected, sensorJsonObj) => {
  textContent.arr = []
  for (const sensor of sensorsSelected) {
    textContent.arr.push(sensorJsonObj[sensor]);
  }
}
const controlTextSlider = (length) => {
  sliderSensorIndex.value + 1 >= length ? sliderSensorIndex.value = 0 : sliderSensorIndex.value += 1
}

// watch sensorJsonObj
watch(sensorJsonObj.obj, (obj) => {
  processTextContent(sensorsSelectedValue.value, obj)
})

// watch sensorsSelectedValue
watch(sensorsSelectedValue, (n) => {
  if(n) {
    // process textSlider
    if (n && n.length > 0) processTextContent(n, sensorJsonObj.obj)
    else {
      sliderSensorIndex.value = 0
      textContent.arr = []
    }
  }
})

watchEffect(() => {
  const {
    Type,
    Sensors: sensorsSelected,
    LoopSecond,
    Layout
  } = texts

  textType.value = Type

  // init controllerLoopSecond, sensorsSelectedValue
  if (sensorsSelectedValue.value !== sensorsSelected || controllerLoopSecond.value !== LoopSecond) {
    // 取得 文字循環速度
    controllerLoopSecond.value = LoopSecond
    sensorsSelectedValue.value = sensorsSelected
    if (intervalID.value) {
      sliderSensorIndex.value = 0
      clearInterval(intervalID.value)
    }
    intervalID.value = setInterval(function () {
      controlTextSlider(textContent.arr.length)
    }, controllerLoopSecond.value * 1000)
  }

  // 取得文字對齊位置
  Object.assign(textLayoutData.obj, Layout[0])

  const {
    Shadow,
    Opacity,
    FontFamily
  } = Layout[0]
  textShadow.value = parseInt(Shadow) >= 0 ? `${Shadow}%` : '35%'
  textOpacity.value = parseInt(Opacity) >= 0 ? `${Opacity}%` : '100%'
  if (FontFamily && FontFamily !== '') mainFontFamily.value = `font_family_${FontFamily}`
  else mainFontFamily.value = initMainFontFamily(props.effectMode)
})

onUnmounted(() => {
  textLayoutData.obj = []
  controllerLoopSecond.value = 0
  sliderSensorIndex.value = 0
  if (intervalID.value) clearInterval(intervalID.value)
})
</script>
